module.exports = __webpack_public_path__ + "img/614.c2af0f9a.jpg";